module.exports = __webpack_public_path__ + "static/media/Race Driver.faec9248.jpg";